













import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'VBarItem'
})
export default class VBarItem extends Vue {
  @Prop({ required: true }) data?: {
    name: string;
    created: string;
    fullCreated: string;
    points: number;
    message: string;
    id: string;
  };
  @Prop({ required: true }) index?: number;
  public style = 'width: 0; margin: 0; padding: 0';

  @Watch('data', { deep: true, immediate: true })
  public setStyle() {
    this.style = 'width: 0';
    setTimeout(() => {
      this.style = `width: ${(this.data?.points || 0) * 9 + 0.1}%; `;
    }, 300);
  }
}
